// UserContext.js
import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { fetchUserDetails, removeCheckoutClientInfo, removeTokens } from '../services/authService';
import { getMyFavouritesByType, getUserStatsObject, recordActivity } from '../services/commonService';

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [my_favourites, setFavourites] = useState(null);

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const userInfo = await fetchUserDetails();
        
        if(userInfo){
          await setMyAllFavourites();
        }
        setUser(userInfo);

      } catch (error) {
        console.error('Error fetching user details:', error);
        // removeTokens();
        // window.location.replace('/login');
      }
    };

    getUserInfo();
  }, []);

  const handleLogout = () => {

      let userStat = getUserStatsObject(
        'Logout',
        "login",
        "Logout",
        window.location.href,
        ''
      );
      userStat.url_details = {'page': window.location.href};
      recordActivity(userStat);

      setTimeout(() => {
        removeCheckoutClientInfo();
        removeTokens();
        window.location.replace('/login');
      }, 100)
  };

  const setUserRole = (role, role_key) => {
    setUser((prevUser) => ({ ...prevUser, role, role_key }));
  };

  const setUserAssingedAccounts = (assigned_accounts) => {
    setUser((prevUser) => ({ ...prevUser, assigned_accounts }));
  };

  const setMyAllFavourites = async () => {
    const favourites =  await getMyFavouritesByType('all');
    setFavourites(favourites)
  }

  const contextValue = useMemo(
    () => ({ user, setUser, handleLogout, setUserRole, setUserAssingedAccounts, my_favourites, setMyAllFavourites  }),
    [user, setUser, handleLogout, setUserRole, setUserAssingedAccounts, my_favourites, setMyAllFavourites]
  );

  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  );
};


export const useUser = () => useContext(UserContext);
